import {IMetadataService, NoLayerSelectedError} from "../services/metadata";
import {L} from "../lt-ng/landcare-toolkit";
import Item = L.tree.Item;
import {_F} from "../utility/func";
import paragraphise = _F.paragraphise;
import LayerService = L.util.LayerService;
import formatScale = _F.formatScale;

interface MetadataComponentBindings {
    layer: Item;
}

export class MetadataComponentController implements ng.IComponentController, MetadataComponentBindings {
    public layer: Item;
    public record: any;
    public minScale: string;
    public maxScale: string;
    public lrisQueryStr: () => string;

    constructor(protected metadataService: IMetadataService) {
        console.log('MetadataComponentController')
    }

    $onChanges(onChangesObj: ng.IOnChangesObject): void {
        if (onChangesObj.layer) {
            const layer = onChangesObj.layer.currentValue as Item;
            this.record = null;

            if (!layer) return;

            const ls = layer && layer.layerService;
            if (ls) {
                this.minScale = ls.maxScale ? formatScale(ls.maxScale) : '';
                this.maxScale = ls.minScale ? formatScale(ls.minScale) : '';
            }

            if (layer.isCustom) {
                this.record = {
                    title: layer.name,
                    description: paragraphise(layer.layerService.longDescription),
                    externalLink: null
                };
            } else {
                this.metadataService.getMetadata([layer]).then(result => {
                    if (layer === this.layer) {
                        console.log('MetadataComponentController set record')
                        this.record = result[0];
                    }
                }, err => {
                    if (!(err instanceof NoLayerSelectedError)) {
                        console.warn(err);
                    }
                });
            }
        }
    }

    isContext() {
        return this.layer.layerType === 'CONTEXT';
    }
}

export class MetadataComponent implements ng.IComponentOptions {
    controller = ['metadataService', MetadataComponentController];
    bindings = {
        layer: '<',
        lrisQueryStr: '<'
    };
    template =
    `<div class="metadata-header" ng-if="$ctrl.record">
        <h4>{{ $ctrl.record.title }}</h4>

        <div class="ng-hide hidden-sm hidden-xs text-right" ng-show="$ctrl.record.externalLink">
            <a ng-href="{{ $ctrl.record.externalLink + '?' + $ctrl.lrisQueryStr() }}" target="_blank" class="obtain-data btn-rounded">Obtain Data</a>
        </div>
    </div>

    <p ng-if="$ctrl.record">
        <span ng-bind-html="$ctrl.record.description"></span>
    </p>
    
    <p ng-if="$ctrl.minScale || $ctrl.maxScale">
        <span ng-if="$ctrl.minScale">Visible on the map above {{ $ctrl.minScale }} scale.</span>
        <span ng-if="$ctrl.maxScale">Visible on the map up to {{ $ctrl.maxScale }} scale.</span>
    </p>`;
}